const model = {
  date: {
    name: "Дата",
    sex: 2,
    required: true,
    checkLength: true,
    min: 10,
    max: 10
  },
  month: {
    name: "Месяц",
    sex: 2,
    required: true,
    checkLength: true,
    min: 7,
    max: 7
  },
  filial: {
    name: "Филиал",
    sex: 1,
    required: false,
    checkLength: false
  }
};

module.exports = model;
